import { Component } from '@angular/core';

@Component({
  selector: 'app-linkbar',
  templateUrl: './linkbar.component.html',
  styleUrl: './linkbar.component.scss',
  standalone: false,
})
export class LinkbarComponent {}
